import { Injectable } from '@angular/core';
import { ActionUpdaterService, ApiError } from './action-updater.service';
import { Http, Response } from '@angular/http';
import { FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { Passengers } from '../models/passenger.model';

@Injectable()
export class ExpressBookingService {

    constructor(private actionUpdaterService: ActionUpdaterService, private http: Http) { }

    getSpecialAssistanceTypes() {
        const url = `/umbraco/api/travel/GetSpecialAssistanceTypes`;
        return this.http.get(url)
            .map(res => res.json());
    }

    getFareTypes() {
        const url = `/umbraco/api/travel/GetFareTypes`;
        return this.http.get(url)
            .map(res => res.json());
    }

    getDefaultPassengerObject() {
        return new Passengers(0, 0, 0, 0, 0, 0, null, null, null, null, null, null, null, null, 0);
    }

    getPassengerObject(passengerOptionsForm: FormGroup) {
        return new Passengers(passengerOptionsForm.controls['adults'].value,
            passengerOptionsForm.controls['concessions'].value,
            passengerOptionsForm.controls['accompaniedChildren'].value,
            passengerOptionsForm.controls['infants'].value,
            passengerOptionsForm.controls['nursedInfant'].value,
            passengerOptionsForm.controls['seatedInfant'].value,
            passengerOptionsForm.controls['concessionCard1'].value,
            passengerOptionsForm.controls['concessionCard2'].value,
            null,
            null,
            passengerOptionsForm.controls['concessionLater'].value,
            passengerOptionsForm.controls['studentCard1'].value,
            passengerOptionsForm.controls['studentCard2'].value,
            passengerOptionsForm.controls['studentLater'].value,
            passengerOptionsForm.controls['students'].value
        );
    }
    getPassengerObjectFromStorage(travelPassengers: any) {
        return new Passengers(travelPassengers['adults'],
            travelPassengers['concessions'],
            travelPassengers['accompaniedChildren'],
            travelPassengers['infants'],
            travelPassengers['nursedInfant'],
            travelPassengers['seatedInfant'],
            travelPassengers['concessionCard1'],
            travelPassengers['concessionCard2'],
            null,
            null,
            travelPassengers['concessionLater'],
            travelPassengers['studentCard1'],
            travelPassengers['studentCard2'],
            travelPassengers['studentLater'],
            travelPassengers['students']
        );
    }
    areConcessionsValid(passengers: Passengers, passengerOptionsForm: FormGroup): boolean {

        const concessions = passengers.concessions,
            concessionCard1 = passengers.concessionCard1,
            concessionCard2 = passengers.concessionCard2,
            concessionLater = passengers.concessionLater

        let isValid = true;
        if (concessions > 0 && !concessionLater) {
            let concessionCard1Valid = true;
            let concessionCard2Valid = true;
            if (concessions === 1 && !concessionCard1) {
                concessionCard1Valid = false;
            } else if (concessions === 2 && (!concessionCard1 || !concessionCard2)) {
                if (!concessionCard1) {
                    concessionCard1Valid = false;
                }
                if (!concessionCard2) {
                    concessionCard2Valid = false;

                }
            }
            if (concessionCard1Valid) {
                passengerOptionsForm.controls['concessionCard1'].setErrors(null);
            } else {
                passengerOptionsForm.controls['concessionCard1'].setErrors({ 'has-error': true });
            }
            if (concessionCard2Valid) {
                passengerOptionsForm.controls['concessionCard2'].setErrors(null);
            } else {
                passengerOptionsForm.controls['concessionCard2'].setErrors({ 'has-error': true });
            }

            isValid = concessionCard1Valid && concessionCard2Valid;
        }
        return isValid;
    }
    areStudentsValid(passengers: Passengers, passengerOptionsForm: FormGroup): boolean {

        const students = passengers.students,
            studentCard1 = passengers.studentCard1,
            studentCard2 = passengers.studentCard2,
            studentLater = passengers.studentLater

        let isValid = true;
        if (students > 0 && !studentLater) {
            let studentCard1Valid = true;
            let studentCard2Valid = true;
            if (students === 1 && !studentCard1) {
                studentCard1Valid = false;
            } else if (students === 2 && (!studentCard1 || !studentCard2)) {
                if (!studentCard1) {
                    studentCard1Valid = false;
                }
                if (!studentCard2) {
                    studentCard2Valid = false;

                }
            }
            if (studentCard1Valid) {
                passengerOptionsForm.controls['studentCard1'].setErrors(null);
            } else {
                passengerOptionsForm.controls['studentCard1'].setErrors({ 'has-error': true });
            }
            if (studentCard2Valid) {
                passengerOptionsForm.controls['studentCard2'].setErrors(null);
            } else {
                passengerOptionsForm.controls['studentCard2'].setErrors({ 'has-error': true });
            }

            isValid = studentCard1Valid && studentCard2Valid;
        }
        return isValid;
    }

    isPassengersCombinationValid = (passengers: Passengers, passengerOptionsForm: FormGroup) => {
        this.actionUpdaterService.announceClear(true);
        let isValid = true;

        const adults = passengers.adults,
            concessions = passengers.concessions,
            seatedInfant = passengers.seatedInfant,
            nursedInfant = passengers.nursedInfant,
            students = passengers.students,
            accompaniedChildren = passengers.accompaniedChildren,
            totalChildren = accompaniedChildren,
            totalAdults = adults + concessions + students + totalChildren,
            infants = passengers.infants,
            totalInfants = nursedInfant + seatedInfant;

        if (accompaniedChildren > 0 && totalAdults === 0) {
            this.actionUpdaterService.announceError(new ApiError(`Children under the age of 15 must travel with an Adult or Concession`));
            isValid = false;
        }
        if (totalInfants > 0 && totalAdults === 0) {
            this.actionUpdaterService.announceError(new ApiError(`Infants (seated and/or nursed) must travel with an Adult or Concession`));
            isValid = false;
        }
        if (totalAdults === 1) {
            if (totalInfants === 2 && (nursedInfant !== 1 || seatedInfant !== 1)) {
                // tslint:disable-next-line:max-line-length
                this.actionUpdaterService.announceError(new ApiError('1 Adult and 2 Infants: 1 infant must be seated and 1 infant must be nursed'));
                isValid = false;
            }
            if (totalInfants > 2 || infants > 2) {
                // tslint:disable-next-line:max-line-length
                this.actionUpdaterService.announceError(new ApiError('A maximum of 2 Infants (seated and/or nursed) can be booked per Adult, Concession or Accompanied Child'));
                isValid = false;
            }
        }
        if (totalInfants > 4) {
            this.actionUpdaterService.announceError(new ApiError(`A maximum of 4 Infants (seated and/or nursed) can be booked`));
            isValid = false;
        }
        if (nursedInfant > totalAdults) {
            // tslint:disable-next-line:max-line-length
            this.actionUpdaterService.announceError(new ApiError('The number of nursed Infants may not exceed the total number of Adults, Concessions and Accompanied Children'));
            isValid = false;
        }

        if ((totalInfants > 0 || infants > 0) && totalAdults === 0) {
            // tslint:disable-next-line:max-line-length
            this.actionUpdaterService.announceError(new ApiError('The number of nursed Infants may not exceed the total number of Adults, Concessions and Accompanied Children'));
            isValid = false;
        }

        if (concessions > 2) {
            this.actionUpdaterService.announceError(new ApiError(`Maximum of 2 'Concessions' allowed`));
            isValid = false;
        }
        if ((concessions + students) > 2) {
            this.actionUpdaterService.announceError(new ApiError(`You cannot have more than two concession fares on a single booking`));
            isValid = false;
        }
        
        if (accompaniedChildren > 0  && adults + concessions + students < 1 ) {
            this.actionUpdaterService.announceError(new ApiError(`'Accompanied Child' must travel with an adult.`));
            isValid = false;
        }

        if (totalAdults === 0) {
            isValid = false;
        }
        if (adults > 0 && concessions > 0 && totalChildren > 0 && seatedInfant > 0) {
            this.actionUpdaterService.announceError(new ApiError('Too many fare types. Maximum allowed is 3.'));
            isValid = false;
        }
        isValid = this.areConcessionsValid(passengers, passengerOptionsForm) && isValid;
        isValid = this.areStudentsValid(passengers, passengerOptionsForm) && isValid;

        return isValid;
    };

    getPassengerSummary(passengerOptionsForm) {
        const adults = passengerOptionsForm.controls['adults'].value,
            concessions = passengerOptionsForm.controls['concessions'].value,
            students = passengerOptionsForm.controls['students'].value,
            children = passengerOptionsForm.controls['accompaniedChildren'].value,
            infants = passengerOptionsForm.controls['infants'].value,
            passengersPretty = [];

        let seatedInfant = passengerOptionsForm.controls['seatedInfant'].value,
         nursedInfant = passengerOptionsForm.controls['nursedInfant'].value;

        if (seatedInfant === 0 && nursedInfant === 0 && infants > 0) {
            if (infants === 1) {
                seatedInfant = 1;
             } else if (infants === 2) {
                seatedInfant = 1;
                nursedInfant = 1;
            }
        }

        if (!!adults) {
            if (adults > 1) {
                passengersPretty.push(adults + 'x Adults');
            } else {
                passengersPretty.push(adults + 'x Adult');
            }
        }
        if (!!concessions) {
            if (concessions > 1) {
                passengersPretty.push(concessions + 'x Concessions');
            } else {
                passengersPretty.push(concessions + 'x Concession');
            }
        }
        if (!!students) {
            if (students > 1) {
                passengersPretty.push(students + 'x Students');
            } else {
                passengersPretty.push(students + 'x Student');
            }
        }
        if (!!children) {
            if (children > 1) {
                passengersPretty.push(children + 'x Children');
            } else {
                passengersPretty.push(children + 'x Child');
            }
        }
        if (!!seatedInfant) {
            if (seatedInfant > 1) {
                passengersPretty.push(seatedInfant + 'x Seated Infants');
            } else {
                passengersPretty.push(seatedInfant + 'x Seated Infant');
            }
        }
        if (!!nursedInfant) {
            if (nursedInfant > 1) {
                passengersPretty.push(nursedInfant + 'x Nursed Infants');
            } else {
                passengersPretty.push(nursedInfant + 'x Nursed Infant');
            }
        }
        if (passengersPretty.length < 1) {
            return 'Choose passenger options';
        }
        return passengersPretty.join(', ');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/express-booking-widget.ts